import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(VApp,[_c('Layout',[_c(VMain,[_c('keep-alive',{attrs:{"include":"entities,userprojects"}},[_c('RouterView',{key:_vm.$route.fullPath})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }